<!--
 * @LastEditors lizijian lizijian@linhuiba.com
 * @Date 2023-10-31 21:10
 * @LastEditTime 2023-11-09 17:11
 * @FilePath /locationpms-pc/src/wkcrmViews/crm/components/ContractOccupyConflict.vue
 * @Description 档期冲突提醒弹窗
-->
<template>
	<crm-dialog ref="wkDialog"
				:visible.sync="visible"
				:append-to-body="true"
				:close-on-click-modal="false"
				width="1080px"
				@close="handleCancel">
		<span slot="title"
			  class="el-dialog__title">冲突档期提醒</span>
		<div class="el-dialog__desc">共{{info.total || 0}}条冲突档期，其中{{info.successCount || 0}}条已成交，{{info.preLockCount || 0}}条预锁</div>
		<CrmTable v-if="info.list"
				  :data="info.list"
				  :height="tableHeight"
				  stripe>
			<el-table-column v-for="(item, index) in fieldList"
							 :key="index"
							 :prop="item.prop"
							 :label="item.label"
							 show-overflow-tooltip>
				<template slot-scope="{ row, column }">
					<template>
						{{ fieldFormatter(row, column) }}
					</template>
				</template>
			</el-table-column>
		</CrmTable>
		<span slot="footer" class="dialog-footer">
			<el-button v-if="info.allowCommit" v-debounce="handleConfirm" type="primary">继续提交</el-button>
			<el-button @click.native="handleCancel">取消</el-button>
		</span>
	</crm-dialog>
</template>

<script>
import ElDialogLoadingMixin from '@/mixins/ElDialogLoading'
import { formatDate } from '@/common/utils/convert'

export default {
  /** 创建合同关联点位档期冲突*/
  name: 'ContractOccupyConflict',
  components: {},
  mixins: [ElDialogLoadingMixin],
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    // /** 没有值就是全部类型 有值就是当个类型 */
    // crmType: {
    //   type: String,
    //   default: ''
    // },
    /** 转移数据 */
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    props: Object
  },
  data() {
    return {
      loading: false, // 加载动画
      visible: false,
      tableHeight: '250px',
      fieldList: [
        {
          prop: 'name',
          label: '点位名称'
        },
        {
          prop: 'activityDates',
          label: '点位活动日期'
        },
        {
          prop: 'shareLimit',
          label: '点位拼场次数上限'
        },
        {
          prop: 'clueStatusName',
          label: '冲突档期状态'
        },
        {
          prop: 'receptionNames',
          label: '冲突档期招商人员'
        },
        {
          prop: 'clueDates',
          label: '冲突档期活动日期'
        },
        {
          prop: 'conflictDates',
          label: '冲突日期'
        }
      ]
    }
  },
  computed: {},
  watch: {
    dialogVisible: {
      handler(newVal) {
        this.visible = newVal
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 格式化字段
     */
    fieldFormatter(row, column) {
      if (column.property === 'name') {
        return row.placeName ? `${row.placeName}-${row.spotName}` : row.spotName
      } else if (column.property === 'activityDates') {
        return `${formatDate(new Date(row.startAt), 'yyyy.MM.dd')}-${formatDate(
          new Date(row.endAt),
          'yyyy.MM.dd'
        )}`
      } else if (column.property === 'clueDates') {
        return `${formatDate(
          new Date(row.clueStartAt),
          'yyyy.MM.dd'
        )}-${formatDate(new Date(row.clueEndAt), 'yyyy.MM.dd')}`
      } else if (column.property === 'conflictDates') {
        return `${formatDate(
          new Date(row.conflictStartAt),
          'yyyy.MM.dd'
        )}-${formatDate(new Date(row.conflictEndAt), 'yyyy.MM.dd')}`
      } else if (column.property === 'receptionNames') {
        return row.receptionNames ? row.receptionNames : '-'
      }
      return row[column.property]
    },

    /**
     * 取消选择
     */
    handleCancel() {
      this.visible = false
      this.$emit('cancel')
    },

    handleConfirm() {
      this.$emit('continueSubmit')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  border-radius: 2px;
  .el-dialog__desc {
    margin-bottom: 10px;
    color: #222222;
  }
  .el-dialog__header {
    height: auto;
    line-height: 24px;
    padding: 15px 20px 10px;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
